import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=43a3c71a&scoped=true&"
import script from "./InformationPage.vue?vue&type=script&lang=js&"
export * from "./InformationPage.vue?vue&type=script&lang=js&"
import style0 from "./InformationPage.vue?vue&type=style&index=0&id=43a3c71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a3c71a",
  null
  
)

export default component.exports